import React from 'react';
import '../promotion/CartPromotion.scss';

export const QuantityStepper = (props) => {
  const decreaseButtonDisabled = props.orderTotal.toLocaleString() == 0 ||
    props.disableDecreaseStepper === true;
  const increaseButtonDisabled = props.disableIncreaseStepper === true;
  return (
    <div
      className={`increment-container-box ${props.disableStepperBox && !props.disableQtyBox
        ? 'qty-stepper-inactive'
        : 'qty-stepper-active'
        } `}
    >
      <button
        disabled={decreaseButtonDisabled}
        className="qty-stepper-decrease"
        onClick={props.decreaseOrder}
      >
        <svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line y1="2.3335" x2="13" y2="2.3335" stroke={decreaseButtonDisabled ? "#9EA0A3" : "#2C2C2C"} strokeWidth="3" />
        </svg>
      </button>
      <div
        className={`stepper-qty ${props.disableStepperBox && !props.disableQtyBox
          ? 'stepper-qty-inactive'
          : 'stepper-qty-active'
          } `}
      >
        {props.orderTotal.toLocaleString()}
      </div>
      <button
        disabled={increaseButtonDisabled}
        className="qty-stepper-increase"
        onClick={props.increaseOrder}
      >
        {increaseButtonDisabled ? <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line y1="6.7829" x2="13" y2="6.7829" stroke="#9EA0A3" strokeWidth="3" />
          <line x1="6.5" y1="0.282959" x2="6.5" y2="13.283" stroke="#9EA0A3" strokeWidth="3" />
        </svg>
          : <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5 8.27783V13.2778H8V8.27783H13V5.27783H8V0.277832H5V5.27783H0V8.27783H5Z" fill="#2C2C2C" />
          </svg>}
      </button>
    </div>
  );
};

export default QuantityStepper;
